import * as customIcons from './custom-icons';
import { materialSymbolIcons } from './material-symbols';
import * as muiIcons from './mui-icons';

const icons = { ...customIcons, ...materialSymbolIcons, ...muiIcons };

export type IconType = keyof typeof icons;
export type IconProps = React.ComponentProps<(typeof icons)[IconType]>;

export * from './mui-icons';
export * from './custom-icons';
export * from './material-symbols';

export default icons;

export function getIcon(icon: IconType) {
    return icons[icon];
}
